import VisibilityIcon from "@mui/icons-material/Visibility"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import { Alert, IconButton, Snackbar, Tooltip } from "@mui/material"
import { AxiosError, AxiosResponse } from "axios"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"

import { AppDispatch } from "../../../store"
import { updateCampaign } from "../../../store/actions/campaigns"

const CampaignDisabled = ({
	bankId,
	campaignName,
	enabled,
	campaignId,
}: {
	campaignName: string
	enabled: boolean
	bankId: string
	campaignId: number
}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch<AppDispatch>()

	const [alertMessage, setAlertMessage] = useState<string | undefined>(
		undefined
	)
	const [isErrorSnackBarOpen, setIsErrorSnackBarOpen] = useState<boolean>(false)

	const patchEnabled = () => {
		dispatch(
			updateCampaign({
				campaignData: { enabled: !enabled },
				idBank: bankId,
				idCampaign: campaignId,
			})
		)
			.then((result: AxiosResponse) => {
				if (result?.meta?.requestStatus === "rejected") {
					if (result?.payload?.status === 403) {
						setAlertMessage(
							t("unauthorized.error.alertMessage", { ns: "common" })
						)
						setIsErrorSnackBarOpen(true)
					}
				}
			})
			.catch((error: AxiosError) => {
				if (error.response && error.response.status === 403) {
					setAlertMessage(
						t("unauthorized.error.alertMessage", { ns: "common" })
					)
					setIsErrorSnackBarOpen(true)
				}
			})
	}

	return (
		<>
			<IconButton color="success" onClick={() => patchEnabled()}>
				{enabled ? (
					<Tooltip
						title={t("activation.tooltip.button.disabled", {
							ns: "campaign",
							campaign: campaignName,
						})}
					>
						<VisibilityOffIcon />
					</Tooltip>
				) : (
					<Tooltip
						title={t("activation.tooltip.button.enabled", {
							ns: "campaign",
							campaign: campaignName,
						})}
					>
						<VisibilityIcon />
					</Tooltip>
				)}
			</IconButton>

			{!!alertMessage && (
				<Snackbar
					sx={{ width: "calc(100% - 50px)" }}
					anchorOrigin={{ vertical: "top", horizontal: "left" }}
					open={isErrorSnackBarOpen}
					autoHideDuration={20000}
					onClose={() => setIsErrorSnackBarOpen(false)}
				>
					<Alert
						onClose={() => setIsErrorSnackBarOpen(false)}
						severity="error"
						variant="filled"
						sx={{ width: "100%" }}
					>
						{alertMessage}
					</Alert>
				</Snackbar>
			)}
		</>
	)
}

export default CampaignDisabled
